const user = {
  // 登录
  login: `/userApi/v1/UserInfo/login`,
  // 登出
  logout: `/userApi/v1/UserInfo/logout`,
  // 获取用户信息
  getInfo: `/userApi/v1/UserInfo/getByRefresh`,
  // 获取菜单
  getMenu: `/userApi/v1/UserInfo/getMenu`,
  // 获取用户信息
  getUserInfo: `/userApi/v1/UserInfo/UserInfo`,
  // 下拉框列表获取
  DetailList: `/userApi/v1/UserInfo/DetailList`,
  // 获取手机号验证码
  getPhoneCode: `/userApi/v1/UserInfo/get_phone_code`,
  // 校验手机验证码
  checkPhoneCode: `/userApi/v1/UserInfo/check_phone_code`,
  // 用户首次登陆修改密码
  changeNoPwd: `/userApi/v1/PassWord/changeNoPwd`,
  // 获取省份地址
  getProvince: `/userApi/v1/UserInfo/province`,
  // 获取省下的市
  getRegion: `/userApi/v1/UserInfo/city`,
  // 获取当前登录用户信息
  getByRefresh: `/userApi/v1/UserInfo/getByRefresh`,
  // 获取推荐头像列表
  getDefineImage: `/userApi/v1/UserInfo/head_image_recommend`,
  // 用户编辑资料
  getEdit: `/userApi/v1/UserInfo/webedit_profile`,
  // 盒子号更改
  updateAccount: `/userApi/v1/UserInfo/update_account`,
  // 用户主页--评价
  user_page_comment: `/userApi/v1/UserHomePage/user_page_comment`,
  // 用户主页--通知
  user_page_notice: `/userApi/v1/UserHomePage/user_page_notice`,
  // 用户主页--回复
  user_page_reply: `/userApi/v1/UserHomePage/user_page_reply`,
  // 用户主页--我回复的
  replyUser: `/userApi/v1/UserHomePage/reply_user`,
  // 上传推荐替换用户头像
  Recommend: `/userApi/v1/UserInfo/head_image_replace`,
  // 用户主页--删除消息通知
  del_notice: `/userApi/v1/UserHomePage/del_notice`,
  // 用户主页--通知阅读更改
  read: `/userApi/v1/UserHomePage/read`,
  // 获取其他用户信息
  other_user_info: `/userApi/v1/UserInfo/other_user_info`,
  // 其他用户主页---评价
  other_user_comment: `/userApi/v1/OtherUserPage/other_user_comment`,
  // 其他用户主页--回复
  other_user_reply: `/userApi/v1/OtherUserPage/other_user_reply`,
  // 其他用户主页--下载记录
  other_user_download_record: `/userApi/v1/OtherUserPage/other_user_download`,
  // 网易反作弊检查
  createAnticheat: `/userApi/v1/WyAnticheat/createAnticheat`,
  // 游戏热搜数据
  hot_search: `/userApi/v1/Essearch/hot_search`,
  // 搜索框提示词   模糊查询
  query_prefix: `/userApi/v1/Essearch/query_prefix`,
  // 搜索框随机提示词
  getCueWord: `/userApi/v1/Essearch/randomCueWord`,
  // 游戏搜索页
  es_search: `/userApi/v1/Essearch/es_search`,
  // 游戏搜索页 -- 张志国
  es_searchv2: `/userApi/v2/Essearch/es_search`,
  // 清空历史记录
  del_history: `/userApi/v1/Essearch/del_history`,
  // 删除单条历史记录
  del_single_history: `/userApi/v1/Essearch/del_single_history`,
  // 获取盒币说明文案信息
  UtilMessageInfo: `/userApi/v1/UtilMessage/info`,
  // 七鱼客服所需用户数据
  getUserGameInfo: `/userApi/v1/QiYu/getUserGameInfo`,
  // 获取我的角色-游戏列表
  withRoleList: `/authApi/user/v1/game/with/role/list`,
  // 获取游戏中所有角色
  gameRoleList: `/authApi/user/v1/game/role/list`,
  // 判断网络是公司还是外部的
  innerCheck: `/userApi/v3/User/innerCheck`,
  // 获取游戏中的最新角色信息
  gameServerRoleList: `/authApi/user/v1/game/server/role/list`,
  // 渠道查询私域引流信息
  queryAttractWithChannel: `/authApi/user/private/v1/queryAttractWithChannel`,
  // 网易易盾风险检测
  riskCheck: `/userApi/v1/WyAnticheat/riskCheck`,
  // 刷新用户区服角色
  refresh: `/authApi/user/v1/game/role/refresh`
};

export default user;
